import { Body, Box, Button, Heading } from '@hover/blueprint';
import { chakra } from '@hover/blueprint/chakra';
import { iUpload } from '@hover/icons';
import React from 'react';

import desktop from 'assets/video/desktop-projects-landscape.mp4';
import mobilePortrait from 'assets/video/mobile-projects-portrait.mp4';

import { useProTranslate } from '../hooks';

const Video = chakra('video', {
  baseStyle: {
    borderRadius: 400,
  },
});

const VideoSection = () => {
  const t = useProTranslate();
  return (
    <Box width="100%">
      <Box
        backgroundColor="#647768"
        flexDirection="column"
        paddingX={{ base: 400, tablet: 1200 }}
        paddingY={{ base: 1000, tablet: 1200 }}
        width="100%"
      >
        <Heading
          color="neutral.0"
          marginBottom={{ base: 700, tablet: 950 }}
          textAlign={{ base: 'left', tablet: 'center' }}
        >
          {t('video.header')}
        </Heading>
        <Box display={{ tablet: 'none' }} paddingX={500} width="100%">
          <Video
            autoPlay
            loop
            muted
            playsInline
            src={mobilePortrait}
            width="100%"
          />
        </Box>
        <Box display={{ mobile: 'none', tablet: 'block' }} width="100%">
          <Video autoPlay loop muted playsInline src={desktop} width="100%" />
        </Box>

        <Box
          backgroundColor="#425045"
          borderRadius={400}
          display={{ base: 'none', tablet: 'flex' }}
          justifyContent="space-between"
          marginTop={{ tablet: 500 }}
          paddingX={700}
          paddingY={500}
          width="100%"
        >
          <Body color="neutral.0">{t('video.description')}</Body>
          <Button colorScheme="light" iconBefore={iUpload}>
            {t('video.buttonText')}
          </Button>
        </Box>
        <Button
          colorScheme="light"
          display={{ base: 'flex', tablet: 'none' }}
          iconBefore={iUpload}
          marginTop={700}
          width="100%"
        >
          {t('video.buttonText')}
        </Button>
      </Box>
    </Box>
  );
};

export { VideoSection };
